/**
 * Autoren: Typen, Daten und Helfer.
 *
 * Redaktionelle Autor:innen der Seite. Blog-Autor:innen kommen aus dem CMS
 * (lib/blog-data.ts → getBlogAuthors) und werden über `fromBlogAuthor` in
 * dieselbe Form gebracht. Hier steht nur, wer als Default-Autor auf
 * Lexikon-/Uni-Detailseiten erscheint.
 */

import type { BlogAuthor } from "@/lib/blog-types";

export type Author = {
  /** URL-Slug, z. B. "ncrechner-redaktion". */
  slug: string;
  name: string;
  /** Optional – ohne Bild rendert AuthorCard/AuthorPage einen Initialen-Avatar. */
  image?: string;
  bio?: string;
  /** Rolle/Titel, z. B. „Medizinstudent, Co-Founder travel4med". */
  designation?: string;
};

export const authors: Author[] = [
  {
    slug: "ncrechner-redaktion",
    name: "ncrechner Redaktion",
    image: "/images/logo.png",
    bio: "Das Redaktionsteam von ncrechner bereitet Zulassung, Bewerbung und die Auswahlverfahren fürs Medizinstudium verständlich und gut recherchiert auf.",
  },
];

/** CMS-Autor:in → Author (für AuthorCard). */
export function fromBlogAuthor(author: BlogAuthor): Author {
  return {
    slug: author.slug,
    name: author.name,
    image: author.avatar,
    designation: author.designation,
  };
}

export function getAuthor(name: string): Author | undefined {
  return authors.find((a) => a.name === name);
}

export function getAuthorBySlug(slug: string): Author | undefined {
  return authors.find((a) => a.slug === slug);
}

export function authorPath(slug: string): string {
  return `/autoren/${slug}/`;
}

/** Initialen für den Avatar-Fallback ohne Bild, z. B. "Lorenz Mader" → "LM". */
export function authorInitials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}
